import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../alert/alert.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private alertService: AlertService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const message = this.extractMessage(error);
        this.alertService.error(message);
        return throwError(error);
      })
    );
  }

  private extractMessage(error: HttpErrorResponse): string {
    if (error.error?.message) {
      return error.error.message;
    }

    if (typeof error.error === 'string') {
      return error.error;
    }

    switch (error.status) {
      case 0:
        return 'Нет соединения с сервером';
      case 400:
        return 'Некорректный запрос';
      case 401:
        return 'Необходима авторизация';
      case 403:
        return 'Доступ запрещён';
      case 404:
        return 'Ресурс не найден';
      case 500:
        return 'Внутренняя ошибка сервера';
      default:
        return error.message || 'Произошла ошибка';
    }
  }
}
